
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"15","fill":"#0D69D5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.543.439a1.499 1.499 0 010 2.118l-4.93 4.934 4.93 4.933a1.498 1.498 0 11-2.117 2.119L.438 8.55a1.499 1.499 0 010-2.119L6.426.44a1.496 1.496 0 012.117 0z"}}),_c('rect',{attrs:{"y":"6","width":"24","height":"3","rx":"1.5"}})])
          )
        }
      }
    